import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { DimensionClassService } from 'services/dimension-class-service';
import { ErrorService } from 'services/error-service';

@autoinject
export class DimensionClassList {
  public tableData: Array<Models.DimensionClass>;
  public activeTableRow: number;
  private ready: boolean = false;

  constructor(
    private dimensionClassService: DimensionClassService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator
  ) {}

  public activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  public attached(params) {
    this.eventAggregator.subscribe('dimensionClassListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();

  }

  public updateView() {
    this.dimensionClassService
      .getAll()
      .then((res) => {
        this.ready = true;
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  public gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('dimension-class-detail', { Id: id });
  }
}
